import AppWeb from "../../../component/platform/AppWeb";
import {ComponentRegistryProvider} from "../../context/componentRegistry/ComponentRegistryContext";
import TabNavigator from "../../../navigation/mobile/tabNavigator/TabNavigator";
import './mobile-app.css'
import AlwaysRememberMe from "../../../component/auth/AlwaysRememberMe";
import ProductQuantityInputButton from "../../../component/product/ProductQuantityInputButton";

const AppMobile = () => {

    return (
        <>
            <div className="mobile-test"/>
            <div className="mobile-app">
                <ComponentRegistryProvider
                    components={{
                        "footer": TabNavigator,
                        "rememberMe": AlwaysRememberMe,
                        "productQuantityInput": ProductQuantityInputButton
                    }}
                >
                    <AppWeb/>
                </ComponentRegistryProvider>
            </div>
        </>
    )

}

export default AppMobile;
